import { useState } from 'react';

export default function ConverterTrial() {
  const [formData, setFormData] = useState({
    platform: '',
    email: '',
    project: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const platforms = [
    'Windows 64位',
    'Linux 64位',
    'MacOS Intel',
    'MacOS ARM'
  ];

  const installationSteps = [
    {
      icon: 'ri-edit-line',
      title: '填写表单',
      description: '获取激活密钥'
    },
    {
      icon: 'ri-file-copy-line',
      title: '复制',
      description: '激活密钥'
    },
    {
      icon: 'ri-folder-open-line',
      title: '解压',
      description: '您的平台文件',
      details: [
        { platform: 'Windows:', instruction: '运行.exe安装文件' },
        { platform: 'Linux:', instruction: '解压.tar.gz文件' },
        { platform: 'Mac:', instruction: '运行.dmg安装文件' }
      ]
    },
    {
      icon: 'ri-book-open-line',
      title: '按照说明',
      description: '下载中的Readme说明，3个简单步骤激活产品'
    }
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // 模拟API调用
      await new Promise(resolve => setTimeout(resolve, 2000));
      setSubmitStatus('success');
      setFormData({ platform: '', email: '', project: '' });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="trial" className="py-20 bg-gradient-to-br from-teal-900 via-slate-900 to-cyan-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            立即开始免费试用
          </h2>
          <p className="text-xl text-gray-300 mb-12">
            体验专业的 PDF 转换服务，无需信用卡，即刻开始使用
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-cloud-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              免费试用
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              联系我们
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-left">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
              <div className="w-12 h-12 bg-teal-500/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-time-line text-2xl text-teal-400"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">快速部署</h3>
              <p className="text-gray-400">
                简单配置即可开始使用，无需复杂的安装过程
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
              <div className="w-12 h-12 bg-teal-500/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-customer-service-2-line text-2xl text-teal-400"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">专业支持</h3>
              <p className="text-gray-400">
                专业技术团队提供全程支持和培训服务
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
              <div className="w-12 h-12 bg-teal-500/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-teal-400"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">安全保障</h3>
              <p className="text-gray-400">
                企业级安全标准，保护您的文档数据安全
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}